import { render, staticRenderFns } from "./ourRoom.vue?vue&type=template&id=f300d940"
import script from "./ourRoom.vue?vue&type=script&lang=js"
export * from "./ourRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports